module.exports = __webpack_public_path__ + "img/4.f28e8c05.jpg";